export default {
      id: "nav-customer-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#nav-customer",
      toString: function () {
        return this.url;
      }
    }